module.exports = __webpack_public_path__ + "assets/img/icon_indices-1.99862bca.svg";